import { Core as Type } from '../../../../../types/Survey/Element'
import { Props } from './types'
import CoreInfoContent from './CoreInfoContent/CoreInfoContent'

const Core: React.FC<Props<Type<any>, any> & { small?: boolean }> = ({ element, small }) => {
  return (
    <div>
      {!!element.title && (
        <div>
          <div
            className={`inline-flex md:flex flex-row-reverse md:flex-row items-start md:items-center gap-1 ${
              small ? 'text-lg' : 'text-xl font-bold'
            }`}
          >
            <span className={small ? 'text-lg' : 'text-xl font-bold'}>{element.title}</span>
            {/* {!!element.helpText && (
              <Tooltip text={element.helpText} className="hidden md:inline-block">
                <QuestionMarkCircleIcon className="w-5 fill-cyan" />
              </Tooltip>
              )} */}
            <CoreInfoContent element={element} small={small} />
          </div>
          {!!element.helpText && <div className="md:hidden text-sm text-gray">{element.helpText}</div>}
        </div>
      )}
      {!!element.description && (
        <div className={`text-gray whitespace-pre-wrap ${!!element.title && !small && 'mt-3'} ${small && 'text-sm'}`}>{element.description}</div>
      )}
    </div>
  )
}

export default Core
